// extracted by mini-css-extract-plugin
export default {"BaseContainer":"BaseContainer_BaseContainer__qnJRm"};